import PropTypes from 'prop-types';
import React from 'react';
const getFormattedVersion = version => {
  let formattedVersion = version;
  const parts = version.split('.');
  if (parts.length === 1) {
    formattedVersion = parts[0];
  } else if (parts.length === 3 && parts[2] === '0') {
    formattedVersion = `${parts[0]}.${parts[1]}`;
  }
  return formattedVersion;
};
const Version = ({
  name,
  build: propsBuild = '',
  tag: _tag = '',
  append: _append = false,
  version: propsVersion = '',
  env: _env = ''
}) => {
  const version = getFormattedVersion(propsVersion);
  const message = `${name} ${version}`;
  const build = [];
  let buildVersion;
  if (propsBuild) {
    build.push(`#${propsBuild}`);
  }
  if (_tag) {
    build.push(_tag);
  }
  if (build.length > 0) {
    buildVersion = `${build.join(', ')}`;
  }
  const output = version ? /*#__PURE__*/React.createElement("span", {
    title: buildVersion
  }, _append ? ',' : '', " ", message, buildVersion && !['production', 'pre-prod', 'beta'].includes(_env) && ` (${build[0]})`) : '';
  return /*#__PURE__*/React.createElement("span", null, output);
};
Version.propTypes = {
  append: PropTypes.bool,
  build: PropTypes.string,
  name: PropTypes.string.isRequired,
  tag: PropTypes.string,
  version: PropTypes.string,
  env: PropTypes.string
};
export default Version;